// extracted by mini-css-extract-plugin
export default {"guardian-name":"styles_guardian-name__96UQU","guardian-relationship-type":"styles_guardian-relationship-type__aN60e"};